import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {ACTION_CHANGE_TYPE} from "../../../@constants";
import {useRepricingFormData} from "../../@hooks";
import {disabledRepricing} from "../../../@signals";


const OPTIONS = [
	{ label: 'Amount', value: ACTION_CHANGE_TYPE.AMOUNT },
	{ label: 'Percentage', value: ACTION_CHANGE_TYPE.PERCENTAGE }
]
export default function RepricingFormActionChangeType() {
	const { actionChangeType, isMatchActionType, handleChangeValue } = useRepricingFormData()

	if (!!disabledRepricing.value)
		return <></>

    return <SelectSeeker
		options={OPTIONS}
		disabled={isMatchActionType}
		value={actionChangeType}
		onChange={e => handleChangeValue('actionType', e.target.value)}
	/>
}